import ErrorBoundary from '@/components/ErrorBoundary';
import { TextSubtitle, TextSubtitleProps } from '@/components/TextSubtitle/TextSubtitle';
import { LabradorComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import { getLabStylingClasses } from 'lib/utils/getLabStylingClasses';

export interface StandaloneTextSubtitleProps extends StandaloneComponentProps {
  text: string;
  options?: Omit<TextSubtitleProps, 'text'>;
}

export const StandaloneTextSubtitle: StandaloneComponent<StandaloneTextSubtitleProps> = ({
  text,
  options,
  ...props
}) => {
  return (
    <ErrorBoundary>
      <TextSubtitle {...options} {...props}>
        {text}
      </TextSubtitle>
    </ErrorBoundary>
  );
};

export const standalone = StandaloneTextSubtitle;

const LabradorTextTitle: LabradorComponent = ({ type, data, meta }) => {
  const { subtitle, fieldSettings } = data;
  const className = getLabStylingClasses(fieldSettings.subtitle);
  return (
    <StandaloneTextSubtitle
      text={subtitle}
      data-content-index={meta.contentIndex}
      options={{ className }}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorTextTitle;
